import React, { useEffect, useState } from "react";
import { Link } from 'react-router-dom';
import { useDispatch } from "react-redux";

import "../../dashboard/dashboard.scss";
import SubModulos from "../../../services/SubModulosService";
import { actions } from "../../../redux/actions";

const Index: React.FC<any> = (props) => {
  const dispatch = useDispatch();

  const id = props.match.params.id || '';
  const [sub, setSub] = useState<any>([]);
  const [error, setError] = useState(false);

  const getSubModulos = () => {
    SubModulos.getSubModulos(id)
      .then((response) => {
        if (response && response.length > 0) {
          setSub(response);
        }
      })
      .catch((error) => {
        setError(error);
      });
  };

  useEffect(() => {
    getSubModulos();
    var _nomeModulo = localStorage.getItem("nome_modulo");
    
    dispatch(actions.addNewTitle(_nomeModulo ? _nomeModulo : "Submodulos"));
    dispatch(actions.addNewPageFilter("filtro"));
    dispatch(actions.addNewHelpText(null));
    // eslint-disable-next-line
  }, [id]);

  return (
    <div className="dashboard-container">
      <div className="sub-modulo">
        {
          <div className="cards-icon">
            <ul>

              {sub &&
                sub.length > 0 &&
                sub.map((s: any, index: number) => (
                  <li key={index} className="cards-icon--item">
                    <Link to={`${s.url}/${s.id}`}>
                      <div className="cards-icon-header">
                        {/* <img src={require(`../../../assets/icons/${s.icon}`)} /> */}
                      </div>
                      <div className="cards-icon-body">{s.nome}</div>
                    </Link></li>
                ))}
            </ul>
          </div>
        }
      </div>
      {error && error}
    </div>
  );
}

export default Index